<ng-container [formGroup]="form">

  <app-base-field-html [form]="form" [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                       [hideField]="hideField" [scrollContainer]="scrollContainer" [inputId]="inputId"
                       (emitPush)="push()">

    <div [ngClass]="{'uk-disabled': readonly}">
      @if (fieldData.typeInfo.multiplicity) {
        <div [formArrayName]="fieldData.name">
          <div appSortable (positionChanged)="onPositionChanged($event)" id="sortable-container">
            @for (input of fieldAsFormArray().controls; track input; let i = $index) {
              <div id="{{i}}" [attr.data-index]="i" class="uk-margin-bottom uk-flex uk-flex-middle">
                <app-rich-text-editor [id]="inputId+'.['+i+']'" [formControlName]="i" class="uk-width-9-10 uk-animation-scale-up"
                          [placeholder]="fieldData.form.placeholder"
                          (ngModelChange)="updateBitSet(fieldData)"
                          (focusin)="focus(i)" (focusout)="containerFocusOut($event, true, i)"
                          [ngClass]="{'uk-form-danger': checkFormValidity()}">
                </app-rich-text-editor>
                @if (formArrayControls.length > 1 && !readonly) {
                  <div class="">
                    <span class="uk-sortable-handle uk-text-center uk-margin-small-left" data-uk-icon="icon: move"></span>
                  </div>
                }
                @if (fieldAsFormArray().length > 1 && editMode) {
                  <a (click)="remove(i); updateBitSet(fieldData); unsavedChangesPrompt()"
                    class="remove-element uk-animation-slide-top-small uk-margin-small-left">
                    <span class="material-icons">clear</span>
                  </a>
                }
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="uk-margin-medium-top uk-width-9-10">
          <app-rich-text-editor [id]="inputId" [formControlName]="fieldData.name"
            (ngModelChange)="updateBitSet(fieldData)" [placeholder]="fieldData.form.placeholder"
            (focusin)="focus()" (focusout)="containerFocusOut($event, true)"
            [ngClass]="{'uk-form-danger': checkFormValidity()}">
          </app-rich-text-editor>
        </div>
      }
    </div>

  </app-base-field-html>

</ng-container>
<!--</form>-->
